export enum Filetype {
  PDF = 'PDF',
  DOCX = 'DOCX',
  DOC = 'DOC',
  TXT = 'TXT',
  RTF = 'RTF',
}
